<template>
    <a href="javascript:;"
       class="text-danger px-1"
       :data-target="modalSelector"
       data-toggle="modal"
       @click="setActiveParams(index,itemID)"
       v-b-tooltip.hover="{ animation: false}"
       :title="$t('labels.reject_item')"
    >
        <i class="fas fa-window-close"></i>
    </a>
</template>

<script>
    export default {
        name: "WithdrawRequestActionsReject",
        props: {
            itemID:{
                type: Number
            },
            index: {
                type: Number
            },
            modalSelector:{
                type:String,
                default:"#modal-reject-transaction"
            },
        },
        data(){
            return {}
        },
        methods:{
            setActiveParams(index,id) {
                this.$emit('input',{
                    activeId : id,
                    activeIndex : index,
                });
            },
        }
    }
</script>

<style scoped>

</style>
